import { IKnmOrder } from '../../../APIPackage/KnmModule/interfaces/IKnmOrder';
import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';

export function createErvkOrderSelectOption(order: IKnmOrder): ISelectOption {
  return {
    ...order,
    id: order.recordId,
    label: order.number,
    value: order.number,
  };
}
